// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import Button from "../atoms/Button";
import Icon from "../atoms/Icon";

type PropsType = {
    title: string,
    description: string,
    cta?: {
        url: string,
        title: string,
    },
};

const ManageClubFooter = (props: {}): React.Node => {
    const { club_management_help } = useSelector(
        (state: any): any => state.options
    );
    const baseClassName = "manage-clubs-footer";
    const classes = [baseClassName, "row"];

    if (!club_management_help) {
        return null;
    } else {
        return (
            <div className={classes.join(" ")}>
                <div className="col-xs-12">
                    <ManageClubFooterItem
                        icon="help"
                        title={club_management_help.title}
                        description={club_management_help.description}
                        cta={club_management_help.cta}
                    />
                </div>
            </div>
        );
    }
};

const ManageClubFooterItem = (props: PropsType): React.Node => {
    const baseClassName = "shop-footer__item";
    const classes = [baseClassName];

    return (
        <div className={classes.join(" ")}>
            <Icon className="shop-footer__item__icon" name="help" />
            <div className="shop-footer__item__title">{props.title}</div>
            <div className="shop-footer__item__description">
                {props.description}
            </div>
            {props.cta && props.cta.url ? (
                <div className="shop-footer__item__ctas">
                    <Button
                        to={props.cta.url}
                        inline={true}
                        small={true}
                        styles={["simple"]}
                    >
                        {props.cta.title}
                    </Button>
                </div>
            ) : null}
        </div>
    );
};

export default ManageClubFooter;
